import { render } from "./ORecepient.vue?vue&type=template&id=a9a886e6&scoped=true"
import script from "./ORecepient.vue?vue&type=script&lang=js"
export * from "./ORecepient.vue?vue&type=script&lang=js"

import "./ORecepient.vue?vue&type=style&index=0&id=a9a886e6&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9a886e6"]])

export default __exports__